<style>
html,body{
  height:100%;
  width: 100%;
  /* overflow:hidden; */
}
/* .root {
  width: 100%;
  height: 100%;
} */
</style>

<template>
  <div class="root">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>




// WEBPACK FOOTER //
// src/App.vue